import React, {
  ReactElement, useEffect, useState,
} from 'react';
import { createPortal } from 'react-dom';

interface TooltipProps {
  targetRef: React.RefObject<HTMLElement>;
  text: string;
  visible: boolean;
  offset: {
    top: number;
    left: number;
  };
  width?: string;
}

export const Tooltip = ({
  targetRef, text, visible, offset, width = '200px',
}: Readonly<TooltipProps>): ReactElement | null => {
  const [coords, setCoords] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  useEffect(() => {
    if (targetRef.current && visible) {
      const rect = targetRef.current.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
      setCoords({
        top: rect.bottom + scrollTop + offset.top,
        left: rect.left + scrollLeft + offset.left,
      });
    }
  }, [targetRef, visible]);

  if (!visible) return null;

  return (
    <>
      {createPortal(
        <div
          style={{
            position: 'absolute',
            top: coords.top,
            left: coords.left,
            backgroundColor: '#20232D',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '4px',
            width,
            zIndex: 899,
            fontSize: '11px',
            transition: 'opacity 0.2s ease',
            textAlign: 'center',
          }}
        >
          {text}
        </div>,
        document.body,
      )}
    </>
  );
};
